import { CHUNK_RECOVERY_KEY, shouldRecoverChunkError } from "~/utils/chunk-recovery"

export default defineNuxtPlugin((nuxtApp) => {
	const posthog = nuxtApp.$posthog as {
		capture?: (event: string, properties?: Record<string, unknown>) => void
	} | undefined
	const recover = (event: Event) => {
		let lastAttemptAt: string | null = null
		try {
			lastAttemptAt = window.sessionStorage.getItem(CHUNK_RECOVERY_KEY)
		} catch (_) {}

		const now = Date.now()
		if (!shouldRecoverChunkError({
			online: navigator.onLine !== false,
			lastAttemptAt,
			now,
		})) return

		event.preventDefault()
		try {
			window.sessionStorage.setItem(CHUNK_RECOVERY_KEY, String(now))
		} catch (_) {}
		try {
			posthog?.capture?.("chunk_load_recovery_started", {
				application_version: useRuntimeConfig().public.appVersion,
				path: window.location.pathname,
			})
		} catch (_) {}
		const path = `${window.location.pathname}${window.location.search}${window.location.hash}`
		reloadNuxtApp({ path, persistState: true })
	}

	window.addEventListener("vite:preloadError", recover)
})
